import React from 'react';
import { Row, Col } from 'antd';
import { Aside, Content, MobileBrand } from './style';
import Heading from '../../components/heading/heading';

const AuthLayout = (WraperContent) => {
    return function () {
        return (
            <Row>
                <Col lg={8} md={8} xs={0}>
                    <Aside>
                        <div className="auth-side-content">
                            <img src={require('../../static/img/auth/topShape.png')} alt="" className="topShape" />
                            <img
                                src={require('../../static/img/auth/bottomShape.png')}
                                alt=""
                                className="bottomShape"
                            />
                            <Content>
                                <img
                                    style={{ width: '150px' }}
                                    // src={require('../../static/img/Logo_Dark.svg')}
                                    src="/icons/logo-with-text.svg"
                                    alt=""
                                    Content
                                />
                                <br />
                                <br />
                                <Heading as="h2">Your Next Customer is a Conversation Away</Heading>
                                <img
                                    className="auth-content-figure"
                                    src={require('../../static/img/login-banner.png')}
                                    alt=""
                                    style={{
                                        width: '30vw',
                                        // zIndex: 9,
                                        // height: '75vh',
                                        objectFit: 'cover',
                                        // position: 'absolute',
                                        // left: 0,
                                        // right: 0,
                                        marginTop: '3rem',
                                        // marginRight: 'auto',
                                        // marginLeft: 'auto',
                                    }}
                                />
                            </Content>
                        </div>
                    </Aside>
                </Col>

                <Col lg={16} md={16} xs={24}>
                    <MobileBrand>
                        <img className="mobile-logo" src="/icons/logo-with-text.svg" alt="CommKraft" />
                        <img
                            className="mobile-illustration"
                            src="/assets/auth/conversation-otp.svg"
                            alt="Secure conversation verification"
                        />
                    </MobileBrand>
                    <WraperContent />
                </Col>
            </Row>
        );
    };
};

export default AuthLayout;
